import { hotjar as hotjarApi } from 'react-hotjar';

if (process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SV) {
  hotjarApi.initialize(Number(process.env.REACT_APP_HOTJAR_ID), Number(process.env.REACT_APP_HOTJAR_SV));
}

export const hotjar =
  process.env.REACT_APP_HOTJAR_ID && process.env.REACT_APP_HOTJAR_SV ? hotjarApi : { identify: () => {} };
